/*
 * @Author: summer
 * @Date: 2019-08-12 09:48:47
 * @LastEditTime: 2019-08-13 16:51:38
 * @LastEditors: Do not edit
 */
import React from "react";
import ReactDOM from 'react-dom';
import ColumnMenu from './columnMenu';
import { isFunction, isUndefined } from '@platform/api';

require('./index.less');

//testType = "autoTest";//自动化测试
/**
 * 获取列模版的一维结构
 */
const getFactorList = ({ columns, finalFactorList }) => {
    return columns.reduce((accumulatorValue, column) => {
        //获取表格列配置
        const { children } = column;
        if (!isUndefined(children)) {
            //判断和并列的情况
            getFactorList({ columns: children, finalFactorList: accumulatorValue });
            return accumulatorValue;
        } else {
            accumulatorValue.push(column);
            return accumulatorValue;
        }
    }, finalFactorList);
};
/**
 * 在表格表体鼠标点击右键绑定事件
 * @param {*} area 表格表体的DOM(主表或者嵌套子表)
 */
function TableColSetting(param) {
    let { tableDom: area, noColSetClass, colSetCallback, removeCustomRightMenu, cancelCustomRightMenu, extendRightMenu } = param
    if (area && this.props && this.props.columns && this.props.columns.length && this.table) {
        this.table.addEventListener(
            'contextmenu',
            createMouseRightMenu.bind(this, { noColSetClass, colSetCallback, removeCustomRightMenu, cancelCustomRightMenu, extendRightMenu }),
        );

        document.addEventListener('click', removeCustomRightMenu);
    }
}

// table willunmonut remove listener add by wanglongx
function removeTableListener(removeCustomRightMenu) {
    this.eventDoms &&
        this.eventDoms.forEach(ele => {
            ele.removeEventListener('contextmenu', createMouseRightMenu);
        });
    document.removeEventListener('click', removeCustomRightMenu);
    // document.removeEventListener('contextmenu', removeCustomRightMenu);
    delete this.eventDoms;
}

//鼠标右键监听事件
function createMouseRightMenu(param, ev) {
    let { noColSetClass, colSetCallback, removeCustomRightMenu, cancelCustomRightMenu, extendRightMenu } = param
    // window.getSelection().toString() 存在选中文本，使用浏览器默认菜单
    //if (window.getSelection().toString()) return;
    //若选中文本是空字符串，则自定义列设置菜单
    ev.preventDefault();
    if (!noColSetClass) {
        ev.stopPropagation();
    }
    let ischeckbox =
        ev.path &&
        ev.path.length &&
        ev.path.some(val => {
            return (
                val.nodeName === 'INPUT' &&
                val.labels &&
                val.labels[0] &&
                val.labels[0].classList &&
                val.labels[0].classList.contains('table-checkbox')
            );
        });
    let isNoSet = ev.target && ev.target.classList && ev.target.classList.contains(noColSetClass);
    removeCustomRightMenu(ev, true);
    if (!ischeckbox && !isNoSet) {
        let section = document.createElement('section');
        section.classList.add('nc-table-setColumnMenu-wrap');
        document.body.appendChild(section);
        ReactDOM.render(
            <div id="nc-table-setColumnMenu">
                <ul className="rightMenu">
                    {/* 其他表格右键 */}
                    {extendRightMenu && extendRightMenu}
                    {/* 列设置 */}
                    <ColumnMenu
                        colsSettingParam={this.props.colsSettingParam}
                        // columns={this.state.bodyColumn}
                        // 对多表头时的模版结构,处理成一维数组
                        columns={getFactorList({ columns: this.props.columns, finalFactorList: [] })}
                        updateColumnHandle={this.props.updateColumnHandle}
                        resetTable={this.resetTable}
                        tableScope={this}
                        cancelColSetting={cancelCustomRightMenu}
                    />

                </ul>
            </div>,
            section,
        );
        isFunction(colSetCallback) && colSetCallback();
        getMouseRightMenuPosition(ev, section);
    }
}

/**
 * 计算鼠标右键已定义菜单的位置
 */
function getMouseRightMenuPosition(ev, section) {
    // clientX/Y 获取到的是触发点相对于浏览器可视区域左上角距离
    const clickX = ev.clientX;
    const clickY = ev.clientY;
    // window.innerWidth/innerHeight 获取的是当前浏览器窗口的视口宽度/高度
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;
    // 获取自定义菜单的宽度/高度
    const rootW = section.offsetWidth;
    const rootH = section.offsetHeight;

    // right为true，说明鼠标点击的位置到浏览器的右边界的宽度可以放下菜单。否则，菜单放到左边。
    // bottom为true，说明鼠标点击位置到浏览器的下边界的高度可以放下菜单。否则，菜单放到上边。
    const right = screenW - clickX > rootW;
    const left = !right;
    const bottom = screenH - clickY > rootH;
    const top = !bottom;
    if (right) {
        section.style.left = `${clickX}px`;
    }
    if (left) section.style.left = `${clickX - rootW}px`;
    if (bottom) section.style.top = `${clickY}px`;
    if (top) section.style.top = `${clickY - rootH}px`;
    if (screenW - clickX < 110 + 32) {
        section.classList.add('nearRight');
    }
}

export { TableColSetting, removeTableListener };
